import { Button, Icon, Modal } from '@fasstech/middle-design-system';

const RemoveUploadFileModal = ({
  onRemove,
  setDisplayModal,
  removeFileMessage = '',
  cancelRemoveFileLabel = '',
  confirmRemoveFileLabel = '',
  isDisplayed
}) => {
  return (
    <Modal
      isDisplayed={isDisplayed}
      className={'relative p-8! flex flex-col items-center rounded-md!'}>
      <div onClick={() => setDisplayModal(false)} data-testid="removeFileClose">
        <Icon name={'cross'} className={'absolute right-7 cursor-pointer'} />
      </div>

      <div className="px-16 text-center">
        <Icon name="document_cross" size={84} className={'m-auto'} />

        <p className={'my-4 text-xl font-bold'}>{removeFileMessage}</p>
      </div>

      <div className="flex gap-x-8">
        <Button
          onClick={() => setDisplayModal(false)}
          variant="secondary"
          data-testid="removeFileCancel">
          {cancelRemoveFileLabel}
        </Button>

        <Button onClick={() => onRemove()} variant="primary" data-testid="removeFileConfirm">
          {confirmRemoveFileLabel}
        </Button>
      </div>
    </Modal>
  );
};

export default RemoveUploadFileModal;
